<template lang="pug">
.modal.fade(tabindex="-1" data-backdrop="static")
  .modal-dialog
    .modal-content.media-manager.mini
      form(v-on:submit.prevent="submit")
        .modal-header
          button.close(type="button" @click="mediaSelectingStore.show = false")
            i.fa.fa-times
          h3 Search Media
        .modal-body
          div.flex-between
            div.btn-group.btn-group-lg
              button.btn.btn-default(type="button" v-on:click="toggleFilters('images')" v-bind:class="{active: filters.images}")
                i.fa.fa-image
              button.btn.btn-default(type="button" v-on:click="toggleFilters('videos')" v-bind:class="{active: filters.videos}")
                i.fa.fa-video-camera
              button.btn.btn-default(type="button" v-on:click="toggleFilters('documents')" v-bind:class="{active: filters.documents}")
                i.fa.fa-file-text-o
            form.form-inline(v-on:submit.prevent="loadMedia({})")
              .input-group.input-group-lg
                input.form-control(type="search" placeholder="Search" v-model="search")
                span.input-group-btn
                  button.btn.btn-default(type="submit")
                    i.fa.fa-search

          br

          p.text-center Select a file from the media library
          hr

          LoaderOverlay(:loading="loading")
            .row
              .file-grid(
                v-for="medium in mediaSelectingStore.searchResults"
                v-on:click="mediaSelectingStore.toggle(medium.id)"
              )
                Medium(:medium="medium" :selected="isSelected(medium.id)")

              .col-sm-12.text-center(v-if="mediaSelectingStore.searchResults.length == 0")
                .alert.alert-info No results were found

            .row
              .col-md-12.text-center
                Pagination(
                  :current="mediaSelectingStore.page.current"
                  :per="perPage"
                  :total-records="mediaSelectingStore.page.total_records"
                  :max-pages="5"
                  @change="changePage"
                )

        .modal-footer
          button.btn.btn-link.text-muted(@click="mediaSelectingStore.show = false" type="button")
            | Cancel
          button.btn.btn-primary(type="submit" :disabled="submitDisabled")
            i.fa.fa-plus
            |
            | Attach
</template>

<script>
  import { mapStores } from 'pinia'
  import { isEmpty, includes } from 'lodash'
  import pLimit from 'p-limit'
  import { useMediaSelectingStore } from '@/stores/media_selecting'

  import LoaderOverlay from './shared/loader_overlay.vue'
  import Medium from './media/medium.vue'
  import Pagination from './shared/pagination.vue'

  export default {
    components: {
      LoaderOverlay,
      Medium,
      Pagination
    },

    props: {
      perPage: {
        type: Number,
        default() { return 6 }
      }
    },

    data() {
      return {
        search: '',
        loading: true,
        filters: {
          images: true,
          videos: false,
          documents: false
        }
      };
    },

    computed: {
      ...mapStores(useMediaSelectingStore),

      submitDisabled() {
        return isEmpty(this.mediaSelectingStore.mediumIds)
      },

      filteredTypes() {
        return Object.keys(this.filters).filter(type => this.filters[type])
      }
    },

    watch: {
      'mediaSelectingStore.show': function (val) {
        if(val) {
          this.loadMedia({})
          jQuery(this.$el).modal('show')
        } else {
          this.reset()
          jQuery(this.$el).modal('hide')
        }
      },
    },

    methods: {
      isSelected(mediumId) {
        return includes(this.mediaSelectingStore.mediumIds, mediumId)
      },

      loadMedia({ page }) {
        const { search, perPage } = this

        this.loading = true

        this.mediaSelectingStore.search(
          {
            search, perPage,
            filterTypes: this.filteredTypes,
            page: page || 1,
          }
        ).then(() => {
          this.loading = false
        })
      },

      changePage(page) {
        this.loadMedia({ page })
      },

      reset() {
        this.mediaSelectingStore.$reset()
        this.search = ''
        this.loading = false
      },

      submit() {
        const limit = pLimit(1)

        this.loading = true

        Promise.all(
          this.mediaSelectingStore.mediumIds.map(mediumId =>
            limit(() => this.$store.dispatch('storyMedia/createFromMedium', { mediumId }))
          )
        ).then(() => {
          this.mediaSelectingStore.mediumIds = []
          this.mediaSelectingStore.show = false
          this.loading = false
        }).catch(() => {
          this.loading = false
        })
      },

      toggleFilters(type) {
        this.filters[type] = !this.filters[type]

        this.loadMedia(this.mediaSelectingStore.page)
      },
    }
  }
</script>

<style scoped>
.flex-between {
  display: flex;
  justify-content: space-between;
}
</style>
